export default function showMoreFaq () {
  document.getElementById('loadMore')?.addEventListener('click', function() {
    const btn = this;
    const nextPage = btn.dataset.nextPage;
    btn.disabled = true;

    // Сохраняем все существующие параметры URL и добавляем параметр page
    const params = new URLSearchParams(window.location.search);
    params.set('page', nextPage);
    const queryString = params.toString();

    fetch(`?${queryString}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll(btn.dataset.newItems);
        const container = document.getElementById(btn.dataset.container);

        newItems.forEach(item => {
          container.appendChild(item.cloneNode(true));
        });

        const newBtn = doc.querySelector('#loadMore');
        if (newBtn) {
          btn.dataset.nextPage = newBtn.dataset.nextPage;
          btn.dataset.currentPage = newBtn.dataset.currentPage;
          btn.disabled = false;
        } else {
          btn.remove();
        }
      })
      .catch(() => {
        btn.disabled = false;
      });
  });
}
